import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetDriversQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetDriversQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: number, status: string, tax_class: string, driver_app_version?: string | null, phone_type?: string | null, user_id?: number | null, home_location_id?: number | null, config?: object | null, home_location?: { __typename?: 'locations', id: number, address_line_one?: string | null, address_line_two?: string | null, city?: string | null, state?: string | null, zip_code?: string | null, latitude?: number | null, longitude?: number | null, place_id?: string | null, timezone?: string | null } | null, region?: { __typename?: 'regions', id: number, timezone?: string | null } | null, user?: { __typename?: 'users', id: number, avatar_url?: string | null, active: boolean, display_name: string, email?: string | null, phone?: string | null, customer_id?: number | null, default_role: string, created_at: string } | null }> };


export const GetDriversDocument = gql`
    query GetDrivers($customerId: bigint!) {
  drivers(
    where: {user: {users_usertocustomers: {customer_id: {_eq: $customerId}}, users_usertoroles: {roletype: {name: {_eq: "driver"}}}, active: {_eq: true}}}
    order_by: {user: {display_name: asc}}
  ) {
    id
    status
    tax_class
    driver_app_version
    phone_type
    user_id
    home_location_id
    home_location {
      id
      address_line_one
      address_line_two
      city
      state
      zip_code
      latitude
      longitude
      place_id
      timezone
    }
    region {
      id
      timezone
    }
    config
    user {
      id
      avatar_url
      active
      display_name
      email
      phone
      customer_id
      default_role
      created_at
    }
  }
}
    `;

/**
 * __useGetDriversQuery__
 *
 * To run a query within a React component, call `useGetDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetDriversQuery(baseOptions: Apollo.QueryHookOptions<GetDriversQuery, GetDriversQueryVariables> & ({ variables: GetDriversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
      }
export function useGetDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
        }
// @ts-ignore
export function useGetDriversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriversQuery, GetDriversQueryVariables>;
export function useGetDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetDriversQuery | undefined, GetDriversQueryVariables>;
export function useGetDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDriversQuery, GetDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDriversQuery, GetDriversQueryVariables>(GetDriversDocument, options);
        }
export type GetDriversQueryHookResult = ReturnType<typeof useGetDriversQuery>;
export type GetDriversLazyQueryHookResult = ReturnType<typeof useGetDriversLazyQuery>;
export type GetDriversSuspenseQueryHookResult = ReturnType<typeof useGetDriversSuspenseQuery>;
export type GetDriversQueryResult = Apollo.QueryResult<GetDriversQuery, GetDriversQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/drivers/queries/getDrivers.query.gql}
 */
export async function getDrivers(
  variables: GetDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetDriversQuery['drivers']>
export async function getDrivers(
  variables: GetDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetDriversQuery>
export async function getDrivers(
  variables: GetDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetDriversQuery['drivers'] | GetDriversQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetDriversQuery>(
    GetDriversDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}